import { HttpInterceptorFn } from '@angular/common/http';
import { injectApiUrl, injectCdnUrl } from '@seatix/shared-config';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  const cdnUrl = injectCdnUrl();
  const apiUrl = injectApiUrl();

  const shouldAddContentType =
    !req.headers.has('Content-Type') &&
    req.responseType !== 'blob' &&
    !(req.body instanceof FormData);

  const headers: { [key: string]: string } = {};

  if (shouldAddContentType) {
    headers['Content-Type'] = 'application/json';
  }

  const isApiRequest = req.url.startsWith(apiUrl);
  const isCdnRequest = req.url.includes(cdnUrl);

  req = req.clone({
    setHeaders: headers,
    withCredentials: isApiRequest,
  });

  if (isCdnRequest) {
    const modifiedRequest = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
      withCredentials: false,
    });

    return next(modifiedRequest);
  }

  return next(req);
};
